import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const BookingHistoryPanel = ({ bookings, onViewDetails, onCancelBooking }) => {
  const getStatusBadge = (status) => {
    const badges = {
      upcoming: { label: 'Upcoming', className: 'badge-success' },
      completed: { label: 'Completed', className: 'bg-muted text-foreground' },
      cancelled: { label: 'Cancelled', className: 'badge-error' },
      waitlist: { label: 'Waitlist', className: 'badge-warning' }
    };
    return badges?.[status] || badges?.upcoming;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatTime = (timeString) => {
    return timeString;
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="History" size={24} color="var(--color-primary)" />
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          My Bookings
        </h3>
      </div>
      {bookings?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12">
          <Icon name="Calendar" size={48} color="var(--color-muted-foreground)" />
          <p className="mt-4 text-sm text-muted-foreground text-center">
            No bookings yet. Start booking classes to see them here.
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {bookings?.map((booking) => {
            const badge = getStatusBadge(booking?.status);
            
            return (
              <div
                key={booking?.id}
                className="flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-muted/50 hover:bg-muted transition-colors duration-250"
              >
                <div className="flex-shrink-0">
                  <div className="w-full sm:w-16 h-32 sm:h-16 rounded-lg overflow-hidden">
                    <Image
                      src={booking?.instructorImage}
                      alt={booking?.instructorImageAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-2">
                    <div className="flex-1 min-w-0">
                      <h4 className="text-base font-semibold text-foreground truncate mb-1">
                        {booking?.className}
                      </h4>
                      <p className="text-sm text-muted-foreground truncate">
                        {booking?.instructor}
                      </p>
                    </div>
                    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${badge?.className} whitespace-nowrap`}>
                      {badge?.label}
                    </span>
                  </div>

                  <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground mb-3">
                    <div className="flex items-center gap-1">
                      <Icon name="Calendar" size={14} />
                      <span>{formatDate(booking?.date)}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Clock" size={14} />
                      <span>{formatTime(booking?.time)}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Timer" size={14} />
                      <span>{booking?.duration} min</span>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onViewDetails(booking?.id)}
                      iconName="Info"
                      iconPosition="left"
                    >
                      Details
                    </Button>
                    {booking?.status === 'upcoming' && (
                      <Button
                        variant="destructive"
                        size="sm"
                        onClick={() => onCancelBooking(booking?.id)}
                        iconName="X"
                        iconPosition="left"
                      >
                        Cancel
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BookingHistoryPanel;